import { createContext, useCallback, useContext, useMemo, useReducer } from 'react';
import { loggingMiddleware } from '../../utils/store';
import { associateObject, disassociateObject, getAssociationSectionList } from './functions';
import { ContactsPropsContext } from './PropsContext';
import { ASSOCIATE_OBJECT, DISASSOCIATE_OBJECT, GET_ASSOCIATION_SECTION_LIST, initialState, reducer, SET_CONTACT_TO_ACCOSIATE, SET_NEW_CONTACT_EMAIL, SET_PARTICIPANT_TO_ACCOSIATE } from './reducer';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContactsContext = /*#__PURE__*/createContext(initialState);
export const ContactsContextProvider = ({
  children
}) => {
  const [contacts, dispatchCTX] = useReducer(loggingMiddleware('contacts')(reducer), initialState);
  const {
    apiWrapper,
    usageTracker
  } = useContext(ContactsPropsContext);
  const asyncFuncArg = useMemo(() => ({
    dispatch: dispatchCTX,
    apiWrapper,
    usageTracker
  }), [apiWrapper, usageTracker]);
  const dispatch = useCallback(action => {
    switch (action.type) {
      case ASSOCIATE_OBJECT:
        associateObject(asyncFuncArg, action.payload);
        break;
      case GET_ASSOCIATION_SECTION_LIST:
        getAssociationSectionList(asyncFuncArg, action.payload);
        break;
      case DISASSOCIATE_OBJECT:
        disassociateObject(asyncFuncArg, action.payload);
        break;
      default:
        {
          dispatchCTX(action);
        }
    }
  }, [asyncFuncArg]);
  const actions = useMemo(() => ({
    setParticpantToAssociate: data => dispatch({
      type: SET_PARTICIPANT_TO_ACCOSIATE,
      payload: data
    }),
    setContactToAssociate: data => dispatch({
      type: SET_CONTACT_TO_ACCOSIATE,
      payload: data
    }),
    setNewContactEmail: value => dispatch({
      type: SET_NEW_CONTACT_EMAIL,
      payload: value
    }),
    getAssociationSectionList: data => dispatch({
      type: GET_ASSOCIATION_SECTION_LIST,
      payload: data
    }),
    associateObject: data => dispatch({
      type: ASSOCIATE_OBJECT,
      payload: data
    }),
    disassociateObject: data => dispatch({
      type: DISASSOCIATE_OBJECT,
      payload: data
    })
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const state = useMemo(() => Object.assign({}, contacts, {
    dispatch,
    contactsActions: actions
  }), [contacts, dispatch, actions]);
  return /*#__PURE__*/_jsx(ContactsContext.Provider, {
    value: state,
    children: children
  });
};